.note-authors {
  color: var(--palette-foreground-secondary);
  font: use-font-secondary("400 14px/16px");
}